// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DevPage-module__devBox--NlgGu {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 70vh;
}

.DevPage-module__devBox--NlgGu>p {
    font-size: 25px;
    color: #6f879c70;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/dev-page/DevPage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".devBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n}\r\n\r\n.devBox>p {\r\n    font-size: 25px;\r\n    color: #6f879c70;\r\n    font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"devBox": `DevPage-module__devBox--NlgGu`
};
export default ___CSS_LOADER_EXPORT___;
